import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        loan: this.formBuilder.group({
          differe: [
            entity?.parameters?.loan?.differe != null
              ? entity.parameters.loan.differe
              : 'AUCUN',
            [Validators.required],
          ],
          durationDiffereInMonth: [
            entity?.parameters?.loan?.durationDiffereInMonth || null,
          ],
        }),
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    const products = _.cloneDeep(this.form.value.products);
    products.forEach(product => {
      product.parameters.loan.differe =
        product.parameters.loan.differe === 'AUCUN'
          ? null
          : product.parameters.loan.differe;
      product.parameters.loan.durationDiffereInMonth =
        product.parameters.loan.differe === 'AUCUN'
          ? null
          : product.parameters.loan.durationDiffereInMonth;
    });

    return products;
  }
}
